<template>
    <SettingsWrapper title="Instance settings" section="Users">
        <v-card class="overflow-hidden">
            <v-tabs v-model="tab" color="primary">
                <v-tab v-for="item in tabs" :key="item.name">
                    <v-icon left small>{{ item.icon }}</v-icon>
                    {{ item.name }}
                </v-tab>
            </v-tabs>
        </v-card>
        <v-tabs-items v-model="tab" class="mt-7">
            <v-tab-item v-for="item in tabs" :key="item.name">
                <component :is="item.component" />
            </v-tab-item>
        </v-tabs-items>
    </SettingsWrapper>
</template>

<script>
import SettingsWrapper from '@/components/SettingsWrapper.vue'
const InstanceUsers = () => import('@/modules/instance/components/InstanceUsers.vue')
const InstanceInvitations = () => import('@/modules/instance/components/InstanceInvitations.vue')

export default {
    name: 'InstanceUserManagement',
    components: { InstanceInvitations, InstanceUsers, SettingsWrapper },
    data() {
        return {
            tab: null,
            tabs: [
                { name: 'Users', icon: 'mdi-account-group-outline', component: 'InstanceUsers' },
                { name: 'Invitations', icon: 'mdi-email-outline', component: 'InstanceInvitations' }
            ]
        }
    },
    methods: {
        fetchData(iid) {
            this.$store.dispatch('instanceStore/fetchInstanceUsers', iid)
            this.$store.dispatch('instanceStore/fetchInstanceInvitations', iid)
        }
    },
    mounted() {
        this.fetchData(this.$route.params.iid)
    },
    watch: {
        '$route.params.iid'(iid, previousIid) {
            if (iid && iid !== previousIid) {
                this.fetchData(iid)
            }
        }
    }
}
</script>
